import { type MutableRefObject, createContext } from "react";

export const StepsContext = createContext<{
  onNextClickRef: MutableRefObject<(() => Promise<void>) | null>;
}>({
  onNextClickRef: {
    current: null,
  },
});
